import * as React from 'react';

import { IUser, IEditProps } from '../types';
import Form from './Form';

export default class Edit extends React.Component<IEditProps> {
  onSubmit = async (values: IUser) => {
    await this.props.update(values);
    this.props.closeRow();
  };

  render() {
    return (
      <Form
        id={this.props.item.id}
        initialValues={this.props.item}
        onSubmit={this.onSubmit}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Users/components/Edit.tsx